import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { showErrorModal } from './show-error-modal';
export const getFailedFetchRuleExecutionResultsModalProps = (t, editorHost, errorMessage, title) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? errorMessage : /*#__PURE__*/React.createElement(Text, null, errorMessage),
    primaryButtonText: t('accessibility-wizard.fetch-rule-execution-results.failed-to-fetch-results-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.fetch-rule-execution-results.failed-to-fetch-results-modal.secondary-button'),
    skin: 'destructive',
    title
  };
};
export const showFailedFetchRuleExecutionResultsModal = async _ref => {
  let {
    handleTryAgain,
    handleCancel,
    a11yWizardAdapter,
    biLogger,
    t,
    editorHost,
    errorMessage,
    title
  } = _ref;
  await showErrorModal({
    ...getFailedFetchRuleExecutionResultsModalProps(t, editorHost, errorMessage, title),
    a11yWizardAdapter,
    editorHost,
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.TryAgain,
        modalType: BiModalTypes.UnableToFetchRuleExecutionResults
      });
      handleTryAgain();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.Cancel,
        modalType: BiModalTypes.UnableToFetchRuleExecutionResults
      });
      handleCancel();
    }
  });
  biLogger.modalView({
    modalType: BiModalTypes.UnableToFetchRuleExecutionResults
  });
};
//# sourceMappingURL=show-failed-fetch-rule-execution-results.js.map